var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDotsHor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C3149;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,25c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S7.8,25,5,25z M5,17c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3 S6.7,17,5,17z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,25c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S22.8,25,20,25z M20,17c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3 S21.7,17,20,17z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,25c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S37.8,25,35,25z M35,17c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3 S36.7,17,35,17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDotsHor);
export default __webpack_public_path__ + "static/media/icon-dots-hor.7851602f9729339b12f8d82cbbf00bf7.svg";
export { ForwardRef as ReactComponent };